export function setRegistrationFields(state, registrationFields) {
  state.registrationFields = registrationFields;
}